import * as React from 'react';
import styled from 'styled-components';
import * as Highcharts from 'highcharts/highstock';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { HighChart } from '@process-advisor/process-miner/components/charts/highChart/highChart';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';

export type Data = []

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;

export const TaskHistory: React.FC = () => {
    const [data, setData] = React.useState<Data[]>([]);
    const [title, setTitle] = React.useState(apiProvider.getEntityUpper() + 's');
    const [metric, setMetric] = React.useState(1);

    let optionsMetrics = [
            { value: 1, label: 'Volume' },
            { value: 2, label: 'Avg Duration (mins)' },
            { value: 3, label: 'Avg Duration (hrs)' },
            { value: 4, label: 'Avg Duration (days)' },
            { value: 13, label: 'Worklogs'},
            { value: 14, label: 'Avg TimeSpent (mins)'},
            { value: 15, label: 'Total Time Spent (mins)'},
        ];
   
    React.useEffect(() => {
        setMetric(1)
        setData(apiProvider.analyticsTaskHistory());
        setTitle(apiProvider.getEntityUpper() + ' History (' + optionsMetrics.find(option => option.value === metric)?.label || 'Volume' + ')')
    }, []);

    React.useEffect(() => {
        const listener = () =>
            setData(apiProvider.analyticsTaskHistory());
        listener();
        apiProvider.on(Event.updateTasks, listener);
        apiProvider.on(Event.applyFilter, listener);
        apiProvider.on(Event.resetFilter, listener);

        return () => {
            apiProvider.off(Event.updateTasks, listener);
            apiProvider.off(Event.applyFilter, listener);
            apiProvider.off(Event.resetFilter, listener);
        };
    }, []);

    const onMetricChange = (metricSelected: number) => {
        setMetric(metricSelected);
        apiProvider.changeAnalyticsTaskHistoryMetric({ metric: metricSelected });
        setData(apiProvider.analyticsTaskHistory());
        setTitle(apiProvider.getEntityUpper() + ' History (' + optionsMetrics.find(option => option.value === metricSelected)?.label || 'Volume' + ')')
    };

    const seriesName = apiProvider.getEntityUpper() + 's'

    const options: Highcharts.Options = {
        chart: {
            style: {
                fontFamily: 'system-ui',
            },
            borderWidth: 2,
            borderColor: '#E0E0E0'
        },
        title: {
            text: title,
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
            },
        },
        plotOptions: {
            line: {
                dataGrouping: {
                    approximation: 'average',
                    units: [
                        [
                            'month', [1]],
                    ],
                },
            },
        },
        legend: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        series: [
            {
                name: seriesName,
                type: 'spline',
                color: '#0B66E4',
                data,
                tooltip: {
                    valueDecimals: 0,
                },
            },
        ],
    };
    
    return (
        <Wrapper>
            <SingleBlock width="10%">
                <Section title='Metric:'/>
            </SingleBlock>
            <SingleBlock width="40%">
            <Dropdown
                    options={optionsMetrics}
                    onChange={onMetricChange}
                    value={metric}/>
            </SingleBlock>
            <SingleBlock width="50%"/>
            <HighChart options={options} constructorType='stockChart' />
        </Wrapper>
    );
};
